import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { checkLocalSavedData, playConfettiAnimation, playTickAnimation, playUnlockPlanetAnimation } from "../helpers/levelManager"
import { deleteSaveData } from "../helpers/levelManager"
import {
	saveCurrentMiniLevelLocally,
	displayTooltip,
	playUISound,
	setAllAlertsToFalse,
	saveEmailsOpenedLocally,
} from "../helpers/levelManager"
import { loadLevel } from "../helpers/levelManager"

export default class StartScene extends Phaser.Scene {
	constructor() {
		super({ key: "StartScene" })
	}

	init() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor
	}

	/**
	 * Create the start scene, with a background image, a start button, and a clear save button.
	 * If there is saved data, load the level from that data.
	 * If there is no saved data, load the first level.
	 */
	create() {
		console.log("scale Factor " + this.scaleFactor)
		this.soundManager = this.scene.get("GameUI").soundManager
		console.log("Sound Manager: " + this.soundManager)
		// Add effect categories with default volumes
		this.soundManager.addCategory("ambient", 3.5)

		// Play background music
		this.soundManager.playMusic("driftingInSpace", { volume: 0.5 })

		let pressed = false
		let backGround = this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG")
			.setScale(this.scaleFactor * 0.25)

		this.checkLocalData()

		let startButton = this.add
			.image(this.gameW / 2, this.gameH / 2, "wideBtn")
			.setInteractive()
			.setScale(this.scaleFactor * 0.65)

		let startText = this.add
			.text(startButton.x, startButton.y - 10 * this.scaleFactor, "START", {
				fontSize: Math.round(this.fontSize + 10 * this.scaleFactor) + "px",
				fill: "#fff",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)

		startButton.on("pointerup", () => {
			if (pressed) return
			pressed = true
			this.cameras.main.fadeOut(500, 0, 0, 0)

			playUISound(this, this.soundManager, "Subtle click 1", 1.5)

			this.cameras.main.on("camerafadeoutcomplete", () => {
				this.loadLevel()

				//DEBUG
				//this.scene.start("MissionOutro")
				//this.scene.start("TabletScene")
				//this.scene.start("TabletUI")
				//this.scene.start("Emails")

				// this.loadingScene = this.scene.get("LoadingScene")

				// this.loadingScene.ensurePlanetLoaded(this, 3, () => {
				// 	// 	this.scene.start("MissionOutro")
				// 	// 	// this.scene.start("TabletScene")
				// 	// 	// this.scene.start("TabletUI")
				// 	this.scene.start("CockpitScene")
				// 	this.scene.start("TabletScene")
				// 	this.scene.start("TabletUI")
				// })
			})
		})

		let clearSaveButton = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 + 110 * this.scaleFactor,
				"activeButton",
			)
			.setInteractive()
			.setScale(this.scaleFactor * 0.5)

		let clearSaveText = this.add
			.text(clearSaveButton.x, clearSaveButton.y - 10, "PLAY AS\nNEW USER", {
				fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
				fill: "#fff",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
				align: "center",
			})
			.setOrigin(0.5)

		clearSaveButton.on("pointerup", () => {
			console.log("DeleteSaveData")
			deleteSaveData()
			this.checkLocalData()

			this.cameras.main.fadeOut(500, 0, 0, 0)

			playUISound(this, this.soundManager, "Subtle click 1", 1.5)

			this.cameras.main.on("camerafadeoutcomplete", () => {
				this.loadLevel()
			})
		})

	}

	checkLocalData() {
		this.userData = checkLocalSavedData()

		console.log("PlanetUnlockAnimsPlayed: " + this.userData.planetsUnlockAnimationShown)
	}

	/**
	 * Loads the level that the user was last on, if that information is saved locally.
	 * If the user has not yet completed the customization level, it loads that.
	 * If the user has completed the customization level, it loads the level that the user was last on.
	 * If there is no saved user data, it loads level 0.
	 * @function
	 * @memberof StartScene
	 */
	loadLevel() {
		//get locally saved level
		let savedLevel = this.userData === null ? 0 : this.userData.userLevel
		let customizationDone =
			this.userData === null ? false : this.userData.customizationCompleted
		console.log(this.userData)
		console.log("Customization Done: " + customizationDone)

		let index = this.userData === null ? 0 : this.userData.currentPlanet

		saveCurrentMiniLevelLocally(0)
		setAllAlertsToFalse()

		//DEBUG: Open emails
		const emailsToOpen = [0, 2, 2]
		saveEmailsOpenedLocally(emailsToOpen[index - 1])

		if (customizationDone === "true") {
			loadLevel(1, this)
			console.log("Customization Done")
		} else {
			loadLevel(savedLevel, this)
			console.log("Customization Not Done")
		}
		//REMOVED DEBUGGER
		// this.scene.start("Customization")
	}
}
